import { Progress as ProgressChakra } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { ProgressProps } from './progress.types'

export default forwardRef(function Progress(
  props: ProgressProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ProgressChakra {...props} ref={ref} translate="no" />
})
